import type { RouteRecordRaw } from 'vue-router';

export const loginRoute: RouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('./pages/LoginPage.vue'),
  meta: { layout: 'empty', public: true },
};

// The passwordless email links here with `?token=…`. The backend builds this
// URL from a configurable path — keep it in sync with that config.
export const magicLinkRoute: RouteRecordRaw = {
  path: '/auth/magic-link',
  name: 'MagicLink',
  component: () => import('./pages/MagicLinkPage.vue'),
  meta: { layout: 'empty', public: true },
};

export const accountRoute: RouteRecordRaw = {
  path: '/account',
  name: 'Account',
  component: () => import('./pages/AccountPage.vue'),
  meta: { layout: 'main' },
};
